
<h5 *ngIf="searchText!=''">
    Result count = {{resultCount}}    
</h5>
<br><br>
<div [innerHTML]="value | searchHighlighter:searchText:'partial'"></div>
